import { cdnTemplate } from 'cdnPreprocessor';

export default [
  function FileUploader() {
    return {
      restrict: 'E',
      templateUrl: cdnTemplate('/file-uploader.html'),
      link: (scope, el) => {
        let fileInput = angular.element(document.getElementById('file'));

        el.on('drag dragstart dragend dragover dragenter dragleave drop', dragStart)
          .on('dragover dragenter', dragOver)
          .on('dragleave dragend drop', dragEnd)
          .on('drop', dragDrop);

        fileInput.on('change', fileChange);

        function dragStart(e) {
          e.preventDefault();
          e.stopPropagation();
        }

        function dragOver(e) {
          el.addClass('is-dragover');
        }

        function dragEnd(e) {
          el.removeClass('is-dragover');
        }

        function dragDrop(e) {
          if (e.originalEvent.dataTransfer.files.length && e.originalEvent.dataTransfer.files[0].type === 'text/csv') {
            scope.$emit('file-upload:file-selected', e.originalEvent.dataTransfer.files[0]);
          }
        }

        function fileChange(e) {
          scope.$emit('file-upload:file-selected', e.currentTarget.files[0]);
        }

        scope.$on('$destroy', function() {
          el.off('drag dragstart dragend dragover dragenter dragleave drop', dragStart)
            .off('dragover dragenter', dragOver)
            .off('dragleave dragend drop', dragEnd)
            .off('drop', dragDrop);
          fileInput.off('change', fileChange);
        });
      }
    }
  }
]


// WEBPACK FOOTER //
// ./source/client/layout-components/file-uploader/file-uploader.js